<template>
<div>
  <div v-for="(userAttrList,idx) in userAttrs.slice().reverse()">
    <div style="height: 10px">
    </div>
    <div v-if="idx === 0">
      影响力
    </div>
    <div v-if="idx === 1">
      能力
    </div>
    <div v-if="idx === 2">
      基础
    </div>
    <div v-if="idx === 3">
      气质特征
    </div>
    <div v-if="idx === 4">
      亲密关系
    </div>
    <div style="height: 10px">
    </div>
    <div v-for="userAttr in userAttrList">
      <div class="title">
        {{ userAttr.name }} <el-tag
          size="mini"
          effect="dark"
          :color="userAttr.color"
          :disable-transitions="false">
        LV{{Math.floor(userAttr.value / 200) + 1}}
      </el-tag>
      </div>
      <div class="subtitle">
        {{userAttr.subtitle}}
      </div>
      <div>
        <el-progress  :color="userAttr.color"  :percentage="idx===2?userAttr.value *10:(userAttr.value % 200) / 2" />
      </div>
    </div>

  </div>
</div>
</template>

<script>
import { getUserAttrs } from '@/api/demo/user'

export default {
  name: 'userAttrs',
  props: {
    userCertId: {
      type: String,
      default: ''
    }
  },
  watch: {
    userCertId: function (newVal, oldVal) {
      this.getUserAttr()
    }
  },
  mounted () {
    this.getUserAttr()
  },
  data: function () {
    return {
      userAttrs: []
    }
  },
  methods: {
    getUserAttr () {
      getUserAttrs(this.userCertId).then(res => {
        this.userAttrs = res
      })
    }
  }
}
</script>

<style scoped>
.title{
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
}
.subtitle{
  font-size: 10px;

  color: #999;
  display: inline-block;
  margin-left: 20px;
}
</style>
